import {
    authorize,
} from '../requests';
import {logEvent, once, reprNetworkError, throttle} from "../utils";
import {useLogin, useLogout, usePrivy} from "@privy-io/react-auth";
import {useStores} from "../stores/root";


export const getLogin = (user: any) => {
    if (user == null) return "Unknown";
    if (user.email) return user.email.address;
    if (user.wallet) return user.wallet.address;
    if (user.github) return user.github.username;
    if (user.google) return user.google.email;
    return "";
}

const getRegisteredSource = (user: any) => {
    if (user.email) return "Email";
    if (user.wallet) return "Wallet";
    if (user.github) return "Github";
    if (user.google) return "Google";
    return "Unknown";
}

const completeTrigger = once()


const onError = throttle((eventPrefix: string, err_code: string) => {
    logEvent(eventPrefix + "user__login_error_" + err_code.toLowerCase())
    setTimeout(() => {
        window.location.reload();
    }, 50);
})

export const useAuth = (isExtension: boolean = false) => {

    const {getAccessToken, ready} = usePrivy();
    const {user: userStore} = useStores()
    const {logout} = useLogout()

    const eventPrefix = isExtension ? 'extension__' : '';

    const logout_ = async () => {
        console.log("Logout")
        userStore.logout()
        await logout()
    };

    const {login} = useLogin({
        onComplete: async (user, isNewUser, wasAlreadyAuth) => {
            if (wasAlreadyAuth) return;
            if (!completeTrigger()) return;
            try {
                userStore.isLoading = true
                const username = getLogin(user);
                const privyId = user.id;
                const source = getRegisteredSource(user);

                if (isNewUser)
                    logEvent(eventPrefix + "user__signup", user)
                else
                    logEvent(eventPrefix + "user__login", user)

                // For using in content.js by extension (and in Avatar.js component)
                localStorage.setItem('itsai_user_id', username);
                console.log("Privy user", user, "isNewUser", isNewUser);

                const data = await authorize(privyId, username, source, await getAccessToken())
                localStorage.setItem('token', data.token);
                userStore.token = data.token;
                userStore.setIsLoading(false)
                await userStore.refresh();
                if (isNewUser) {
                    window.location.href = '/login?token=' + data.token;
                }
                // After successful login TODO?
                // window.location.href = '/login?token=' + e.token;
            } catch (e) {
                if (isNewUser)
                    logEvent(eventPrefix + "user__signup_error_server", reprNetworkError(e))
                else
                    logEvent(eventPrefix + "user__login_error_server", reprNetworkError(e))
                userStore.setError('Failed to login');
            }
        },
        onError: (err_code) => {
            onError(eventPrefix, err_code)
        }
    });

    return {
        logout: logout_,
        login: login,
        ready: !userStore.isLoading && ready,
        authenticated: userStore.isAuthenticated()
    };
}
